import { ActionBrick, registerBrick } from 'olympe';

export default class CreateRejectedNotePayload extends ActionBrick {
  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {string} fieldName
   * @param {string} oldValue
   * @param {string} newValue
   * @param {function()} forwardEvent
   * @param {function(ListDef)} setUpdates
   * @param {function(ListDef)} setFilters
   */
  update(
    $,
    [fieldName, oldValue, newValue],
    [forwardEvent, setUpdates, setFilters]
  ) {
    const updates = [];
    const filters = [];

    updates.push({ updatedField: fieldName, updatedValue: newValue });
    filters.push({ field: fieldName, value: oldValue });
    setUpdates(updates);
    setFilters(filters);
    forwardEvent();
  }
}

registerBrick('0199f0a834a8286ed6b3', CreateRejectedNotePayload);
